
import moment from 'moment';
import { Component, Vue, Emit, Mixins } from 'vue-property-decorator';
import LogUtils from 'panda-log';
@Component
export default class DataTable extends Vue {
  mounted() {}
}
